export default __webpack_public_path__ + "static/media/remove-tab.e522df0a.svg";